module.exports = __webpack_public_path__ + "img/meal-details.bdabe213.png";